import { render, staticRenderFns } from "./UserManual.vue?vue&type=template&id=3af24a29&scoped=true&"
import script from "./UserManual.vue?vue&type=script&lang=js&"
export * from "./UserManual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af24a29",
  null
  
)

export default component.exports